import { useMutation } from 'react-query';

import { resetClustersList as mutationFn } from 'api/endPoints/resetClustersList';

export const useMutationResetCluster = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    clusterId: number;
    clusterType: string;
}
